var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('br'),_c('p',[_vm._v("GPS")]),_c('iframe',{attrs:{"src":"https://preyproject.com/es/","width":"100%","height":"600"}})])
}]

export { render, staticRenderFns }